import { render, staticRenderFns } from "./About.vue?vue&type=template&id=647b3c02&scoped=true&"
import script from "./About.ts?vue&type=script&lang=ts&"
export * from "./About.ts?vue&type=script&lang=ts&"
import style0 from "./About.scss?vue&type=style&index=0&id=647b3c02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b3c02",
  null
  
)

export default component.exports